import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialCampaignsState } from './initialState'
import { CampaignsState, UserListCampaignItem } from './types'

type UserListsRootState = {
  userLists: { campaigns: CampaignsState }
}

const slice = createSlice({
  name: 'userLists/campaigns',
  initialState: initialCampaignsState,
  reducers: {
    setCampaigns: (
      state,
      action: PayloadAction<{
        userListId: number
        campaigns: UserListCampaignItem[]
      }>
    ) => {
      const { userListId, campaigns } = action.payload
      state.entries[userListId] = campaigns
    },
  },
})

export const reducer = slice.reducer
export const { setCampaigns } = slice.actions

export const selectCampaignsByListId = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.campaigns.entries[userListId] || []

export const selectCampaignsPagination = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.campaigns.pagination[userListId] || null

export type { UserListCampaignItem, CampaignsState } from './types'
